import { render, staticRenderFns } from "./HeaderRegistration.vue?vue&type=template&id=423d1d87"
import script from "./HeaderRegistration.vue?vue&type=script&lang=js"
export * from "./HeaderRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports